"use strict";
exports.__esModule = true;
var AndroidBadgeIcon_1 = require("./AndroidBadgeIcon");
exports.AndroidBadgeIcon = AndroidBadgeIcon_1["default"];
var AppleBadgeIcon_1 = require("./AppleBadgeIcon");
exports.AppleBadgeIcon = AppleBadgeIcon_1["default"];
var OpenSignIcon_1 = require("./OpenSignIcon");
exports.OpenSignIcon = OpenSignIcon_1["default"];
var IconSizes;
(function (IconSizes) {
    IconSizes[IconSizes["TINY"] = 12] = "TINY";
    IconSizes[IconSizes["SMALL"] = 16] = "SMALL";
    IconSizes[IconSizes["MEDIUM"] = 24] = "MEDIUM";
    IconSizes[IconSizes["LARGE"] = 32] = "LARGE";
    IconSizes[IconSizes["X_LARGE"] = 48] = "X_LARGE";
    IconSizes[IconSizes["XX_LARGE"] = 64] = "XX_LARGE";
    IconSizes[IconSizes["XXX_LARGE"] = 96] = "XXX_LARGE";
    IconSizes[IconSizes["HUGE"] = 128] = "HUGE";
})(IconSizes = exports.IconSizes || (exports.IconSizes = {}));
